<template>
    <div>
        <v-server-table :ref="'historyList' + record_type" :url="`/history/list?record_type=${record_type}&record_id=${record_id}`" :columns="columns" :options="options">

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="last_name" slot-scope="props">
                {{ props.row.first_name }} {{ props.row.last_name }}
            </template>

            <template slot="attribute" slot-scope="props">
                {{ props.row.attribute }} <label class="badge badge-danger small" v-if="props.row.history_type === 'Destroy'">DELETED</label>
            </template>

            <template slot="child_row" slot-scope="props">
                {{ props.row.note }}
            </template>
        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: {
            record_type: {
                type: String,
                required: true
            },

            record_id: {
                type: Number,
                required: true
            },
        },

        data() {
            return {
                userTimezone: this.$root.timezone,
                columns: ['created_at', 'last_name', 'attribute', 'old_value', 'new_value'],
                options: {
                    headings: {
                        created_at: 'Timestamp',
                        last_name: 'User',
                        attribute: 'Changed Field',
                        old_value: 'Old Value',
                        new_value: 'New Value',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'history.created_at',
                    },
                    texts:{
                        filterPlaceholder:"Search History",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('historyCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Add the type
                        data.asset_type = this.record_type;
                        data.asset_id = this.record_id;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
